module.exports = __webpack_public_path__ + "img/pattern-yellow-rotated.bc97e59.png";